import { render, staticRenderFns } from "./MailSegnalazioneProposal.vue?vue&type=template&id=53cfe230&scoped=true"
import script from "./MailSegnalazioneProposal.vue?vue&type=script&lang=js"
export * from "./MailSegnalazioneProposal.vue?vue&type=script&lang=js"
import style0 from "./MailSegnalazioneProposal.vue?vue&type=style&index=0&id=53cfe230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cfe230",
  null
  
)

export default component.exports